<div class="flex space-x-2">
    <div class="flex items-baseline text-gray-600 text-lg">
        <div class="font-medium">
            <span *ngIf="rating; else unrated">{{ rating | number: '0.1-1' }}</span>
            <ng-template #unrated>?</ng-template>
        </div>
        <div class="ml-1 text-gray-400">/ 5</div>
    </div>
    <kb-star-rating [rating]="rating" [size]="'lg'"></kb-star-rating>
</div>
<p class='text-sm text-gray-600'>Based on {{ reviewCount }} reviews</p>
